export default __webpack_public_path__ + "static/media/portfolio-152.7c0016f9.jpg";